import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {IngredientCreateAllergensPage} from "../../ingredient-create/ingredient-create-allergens/ingredient-create-allergens";

/**
 * Generated class for the IngredientViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-view-allergens',
    templateUrl: 'ingredient-view-allergens.html',
})
export class IngredientViewAllergensPage {
    @Input() ingredient: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
    }

    edit() {
        this.navCtrl.push(IngredientCreateAllergensPage,{
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            allergens: this.ingredient.allergens,
            ingredient_name: this.ingredient.name
        })
    }

}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-allergens/ingredient-view-allergens.ts